import { Component, Input } from '@angular/core';

import { AnalyticsService } from 'rev-shared/analytics/Analytics.Service';
import { GridType } from 'rev-shared/analytics/Constant';
import { mediumDateTimeValueFormatter } from 'rev-shared/ui/dataGrid/valueFormatters/MediumDateTimeValueFormatter';

import styles from 'rev-portal/admin/reports/AdminReports.module.less';

enum ViewsColumnPickerGroup {
	METRICS,
	SESSION,
	SYSTEM,
	USER,
	VIDEO
}

@Component({
	selector: 'views-grid',
	templateUrl: './ViewsGrid.Component.html'
})
export class ViewsGridComponent {
	@Input() public accountId: string;
	@Input() public header: string;

	public readonly ViewsColumnPickerGroup = ViewsColumnPickerGroup;
	public readonly mediumDateTimeValueFormatter = mediumDateTimeValueFormatter;
	public readonly GridType = GridType;
	public readonly pageSize = 25;
	public readonly styles = styles;

	constructor(
		public AnalyticsService: AnalyticsService
	) { }
}
